import { JsonObject, JsonProperty } from 'json2typescript';
import { Shipment } from './shipment-model';
import { InvoiceNoShipment } from './invoice-no-shipment-model';

@JsonObject('Invoice')
export class Invoice extends InvoiceNoShipment {
  @JsonProperty('shipment', Shipment, true) shipment: Shipment = undefined;
}
